<script>
import Login from "@/views//modals/Login";
import Signup from "@/views//modals/Signup";
import Contact from "@/views//modals/Contact";
import ModifyUser from "@/views//modals/ModifyUser";
import ModifyAdmin from "@/views//modals/ModifyAdmin";
import ModifyTown from "@/views//modals/ModifyTown";
import ErrorModal from "@/views//modals/Error";
import ErrorMailing from "@/views//modals/ErrorMailing";
import ResetPassword from "@/views//modals/ResetPassword";
import TermsConsent from "@/views//modals/TermsConsent";
import ModifyPassword from "@/views//modals/ModifyPassword";
import Loading from "@/views//modals/Loading";
import EditUserData from "@/views//modals/EditUserData";
import EditUserTown from "@/views//modals/EditUserTown";
import Logout from "@/views//modals/Logout";
import bus from "@/bus";
import router from "../router"

export default {
  components: {
    login: Login,
    signup: Signup,
    contact: Contact,
    modifyUser: ModifyUser,
    modifyTown: ModifyTown,
    modifyAdmin: ModifyAdmin,
    error: ErrorModal,
    errorMailing: ErrorMailing,
    resetPassword: ResetPassword,
    loading: Loading,
    termsConsent: TermsConsent,
    modifyPassword: ModifyPassword,
    editUserData: EditUserData,
    editUserTown: EditUserTown,
    logout: Logout,
  },
  data() {
    return { currentModal: null, params: {} };
  },
  computed: {
    currentModalComponent() {
      const { currentModal } = this;
      if (!currentModal) return null;
      return `${currentModal}`;
    },
    computedContainerClass() {
      if (this.currentModal === "loading") {
        return { "items-center": true };
      }
      return { "items-start": true };
    },
  },
  created() {
    bus.on("openModal", this.openModal);
    bus.on("closeModal", this.closeModal);
  },
  mounted() {
    window.addEventListener("keyup", this.handleKeyup);
  },
  beforeUnmount() {
    window.removeEventListener("keyup", this.handleKeyup);
  },
  methods: {
    openModal({ modal, params }) {
      this.params = params || {};
      this.currentModal = modal;
    },
    closeModal() {
      if (this.currentModal == "logout") {
        router.push({ path: '/signup-login' })
      }
      this.currentModal = null;
    },
    handleKeyup(event) {
      // If  ESC key was pressed...
      if (event.keyCode === 27) {
        this.closeModal();
      }
    },
  },
};
</script>

<template>
  <div v-if="currentModal !== null" data-cy="modal"
    class="fixed top-0 left-0 w-screen h-screen flex justify-center z-30 overflow-auto" :class="computedContainerClass">
    <div class="mt-10 z-50 max-h-screen flex justify-center" tabindex="0" @keyup.esc="closeModal">
      <component :is="currentModalComponent" :params="params" />
    </div>
    <div id="modalBg" data-cy="modalBg" class="fixed top-0 left-0 h-full w-full bg-black-50" @click="closeModal" />
  </div>
</template>
